<template>
  <div class="o-home">
    <BosNotificationBanner />
    <BosMessageBanner :store="$store" />
    <bos-fair-listing
      :title="
        $t('home.fairListing.active.title')
          .replace('{firstname}',
          ($store.getters['oidcUser'] ? $store.getters['oidcUser'].given_name : '')
        )
          .replace('{lastname}',
          ($store.getters['oidcUser'] ? $store.getters['oidcUser'].family_name : '')
        )
      "
      :titleSuffix="$t('home.fairListing.active.titleSuffix')"
      :list="standsActive"
      modalId="FairListingActiveModal"
      :modalTitle="$t('home.fairListing.active.modal.title')"
    />
    <marketing-teaser :teaserType="1" />
    <bos-logo-listing :title="$t('home.logoListing.title')" />
    <bos-past-fair-listing
      :title="$t('home.fairListing.past.title')"
      :list="pastFairs"
    />
  </div>
</template>

<script>
import BosNotificationBanner from '../components/BosNotificationBanner'
import BosMessageBanner from '../components/BosMessageBanner'
import BosHero from '../components/BosHero'
import BosFairListing from '../components/BosFairListing'
import BosPastFairListing from '../components/BosPastFairListing'
import MarketingTeaser from '../components/MarketingTeaser'
import teaserImage from '../assets/images/rubiks-cubes.png'
import { filter } from 'lodash'
import BosLogoListing from '../components/BosLogoListing'
import ApiService from '../services/ApiService'
import { getLocalizationInExcludes, localize } from '@/assets/js/helper'
import rollbar from 'rollbar';

export default {
  data: function() {
    return {
      showModal: false,
      heroOpen: true,
      heroTitle: 'BEA 2020 - Jetzt anmelden',
      heroSubTitle:
        'Die Stand-Anmeldung für die BEA 2020 ist ab sofort freigeschalten. Reservieren Sie sich ihren Stand noch heute.',
      heroButtonLabel: 'Anmeldung starten',
      heroButtonUrl: '#'
    }
  },
  computed: {
    list() {
      const rubinFairs = this.$store.getters['fair/getWithBooths']
      let fairs = []
      //split by booth
      rubinFairs.forEach(fair => {
        if (fair !== undefined && fair.booths) {
          fair.booths.forEach(booth => {
            let addFair = JSON.parse(JSON.stringify(fair))
            addFair.booth = booth
            fairs.push(addFair)
          })
        }
      })
      return fairs
    },
    standsActive() {
      let inAndExcludes = getLocalizationInExcludes(this.$i18n.locale)
      return localize(
        this.list.filter(item => {
          const startTime = new Date(item.publish.start)
          const endTime = new Date(item.publish.end)
          endTime.setUTCHours(23)
          endTime.setUTCMinutes(59)
          endTime.setUTCSeconds(59)
          endTime.setUTCMilliseconds(999)
          const now = new Date()
          return startTime <= now && endTime >= now
        }),
        inAndExcludes.include,
        inAndExcludes.exclude
      ).sort(function(a, b) {
        let renewA = a.booth.status === 'OP'
        let renewB = b.booth.status === 'OP'

        //frist the renew links
        if (renewA && !renewB) {
          return -1
        } else if (!renewA && renewB) {
          return 1
        } else {
          //then by fairstart
          if (a.duration.start < b.duration.start) {
            return -1
          } else if (a.duration.start > b.duration.start) {
            return 1
          } else {
            // by fair...
            let titleA = a.rubin[0].titel.toLowerCase()
            let titleB = b.rubin[0].titel.toLowerCase()
            if (titleA < titleB) {
              return -1
            } else if (titleA > titleB) {
              return 1
            } else {
              if (a.booth.regiNr > b.booth.regiNr) {
                return -1
              } else if (a.booth.regiNr < b.booth.regiNr) {
                return 1
              }
              return 0
            }
          }
        }
        return -1
      })
    },
    pastFairs() {
      let inAndExcludes = getLocalizationInExcludes(this.$i18n.locale)
      const localized = localize(
        this.list.filter(item => {
          const endTime = new Date(item.publish.end)
          endTime.setUTCHours(23)
          endTime.setUTCMinutes(59)
          endTime.setUTCSeconds(59)
          endTime.setUTCMilliseconds(999)
          const now = new Date()
          return endTime <= now
        }),
        inAndExcludes.include,
        inAndExcludes.exclude
      )

      let fairSeries = []

      localized.forEach(fair => {
        let serie = fairSeries.find(item => item.code == fair.rubin[0].reiheId)
        if (serie == undefined) {
          serie = {
            title: fair.rubin[0].reiheBezeichnung,
            code: fair.rubin[0].reiheId,
            last: new Date(0)
          }
          fairSeries.push(serie)
        }

        if (new Date(fair.duration.end) > serie.last) {
          serie.last = new Date(fair.duration.end)
          serie.fairCode = fair.rubin[0].vgId
        }
      })

      return fairSeries
    }
  },
  methods: {
    closeHero() {
      this.heroOpen = false
    }
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'setOidcAuth':
        ApiService.setAccessToken(state.oidcStore.access_token)
          if (process.env.VUE_APP_DEBUGMODE) {
            rollbar.debug('TOKEN:' + state.oidcStore.access_token);
          }
          break
      }
      //console.log(mutation.type)
    })
    this.$store.dispatch('fair/getWithBooths')
    this.$store.dispatch('fair/getOneShopFairs')
  },
  name: 'home',
  components: {
    BosLogoListing,
    BosFairListing,
    BosPastFairListing,
    BosNotificationBanner,
    BosMessageBanner,
    MarketingTeaser
  }
}
</script>
